import React from "react";
import { X } from "lucide-react";
import { useTheme } from "../ThemeProvider";
import { getSeliseCSuiteColor, getThemeColor } from "./seliseColors";

function getCLevelColor(cSuiteNodes, cLevel, theme) {
  const index = cSuiteNodes.findIndex((c) => c.id === cLevel.id);
  const fallback = (theme === "selise" || theme === "dark")
    ? getSeliseCSuiteColor(index)
    : "#3465a4";
  return getThemeColor(cLevel.color, theme, fallback);
}



export default function CLevelAssign({ cSuiteNodes, assignedCLevelId, onAssign, isAdmin }) {
  const { theme } = useTheme();
  if (!cSuiteNodes || cSuiteNodes.length === 0) return null;

  if (!isAdmin && !assignedCLevelId) return null;

  const assigned = cSuiteNodes.find((c) => c.id === assignedCLevelId);

  if (!isAdmin && assigned) {
    return (
      <div
        className="w-6 h-6 rounded-full flex items-center justify-center text-white text-[8px] font-bold flex-shrink-0"
        style={{ backgroundColor: getCLevelColor(cSuiteNodes, assigned, theme) }}
        title={`${assigned.title} — ${assigned.name}`}
      >
        {assigned.title}
      </div>
    );
  }

  return (
    <div className="flex gap-1 flex-shrink-0 items-center">
      {cSuiteNodes.map((c) => {
        const isActive = c.id === assignedCLevelId;
        const activeColor = getCLevelColor(cSuiteNodes, c, theme);
        return (
          <button
            key={c.id}
            onClick={() => onAssign(isActive ? null : c.id)}
            className={`w-6 h-6 rounded-full flex items-center justify-center text-[8px] font-bold transition-all ${
              isActive
                ? "text-white"
                : "text-gray-400 bg-gray-100 hover:bg-gray-200"
            }`}
            style={isActive ? { backgroundColor: activeColor } : {}}
            title={`${c.title} — ${c.name}`}
          >
            {c.title}
          </button>
        );
      })}
      {assignedCLevelId && (
        <button
          onClick={() => onAssign(null)}
          className="text-gray-300 hover:text-red-500 transition-colors"
          title="Clear C-level"
        >
          <X className="w-3.5 h-3.5" />
        </button>
      )}
    </div>
  );
}